<div
  #overlayOrigin="cdkOverlayOrigin"
  cdkOverlayOrigin
  class="chip-multi-select-shell"
  [class.chip-multi-select-shell--panel-open]="isPanelOpen()"
  [class.chip-multi-select-shell--disabled]="disabled()"
>
  <div
    #trigger
    class="chip-multi-select-field"
    [attr.tabindex]="disabled() ? -1 : 0"
    [attr.aria-disabled]="disabled() ? 'true' : null"
    [attr.aria-label]="comboboxLabel()"
    [attr.aria-labelledby]="comboboxLabelledBy()"
    (click)="onTriggerClick()"
    (keydown)="onTriggerKeydown($event)"
  >
    <mat-chip-set aria-label="Selected options" class="selected-chips">
      @for (chip of selectedChips(); track chip.value) {
      <mat-chip [disableRipple]="true">
        {{ chip.label }}

        <button
          type="button"
          matChipRemove
          [disabled]="disabled()"
          [attr.aria-label]="'Remove ' + chip.label"
          (click)="removeOption(chip.value, $event)"
        >
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </mat-chip>
      }
    </mat-chip-set>

    @if (selectedValues().length > 0) {
    <button
      type="button"
      class="clear-all"
      aria-label="Clear selected options"
      [disabled]="disabled()"
      (click)="clearSelection($event)"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
    }
  </div>

  <button
    type="button"
    class="dropdown-toggle"
    aria-haspopup="listbox"
    [attr.aria-label]="isPanelOpen() ? 'Close options' : 'Open options'"
    [attr.aria-expanded]="isPanelOpen()"
    [disabled]="disabled()"
    (click)="toggleDropdown($event)"
  >
    <mat-icon aria-hidden="true">
      {{ isPanelOpen() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </mat-icon>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="overlayOrigin"
    [cdkConnectedOverlayOpen]="isPanelOpen()"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayViewportMargin]="8"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (overlayOutsideClick)="onOutsideClick($event)"
    (attach)="syncOverlayGeometry()"
    (detach)="closeDropdown()"
  >
    <div #panel class="chip-multi-select-panel">
      @if (loading()) {
      <div class="loading-center" aria-live="polite">
        <mat-spinner diameter="20" aria-hidden="true"></mat-spinner>
        <span class="visually-hidden">Loading options</span>
      </div>
      } @else {
      <div class="chip-multi-select-listbox" [id]="listboxId">
        @for (option of normalizedOptions(); track option.value; let i = $index)
        {
        <div
          class="chip-multi-select-option"
          tabindex="-1"
          [id]="option.id"
          [class.chip-multi-select-option--active]="i === activeIndex()"
          (click)="toggleOption(option)"
          (keydown)="onOptionKeydown(option, $event)"
        >
          <mat-pseudo-checkbox
            aria-hidden="true"
            [state]="selectedSet().has(option.value) ? 'checked' : 'unchecked'"
          ></mat-pseudo-checkbox>

          <span class="chip-multi-select-option__label">
            {{ option.label }}
          </span>
        </div>
        }
      </div>
      }
    </div>
  </ng-template>
</div>
